import { render, staticRenderFns } from "./PracticeMemberCard.vue?vue&type=template&id=fef91eb4&scoped=true"
import script from "./PracticeMemberCard.vue?vue&type=script&lang=js"
export * from "./PracticeMemberCard.vue?vue&type=script&lang=js"
import style0 from "./PracticeMemberCard.vue?vue&type=style&index=0&id=fef91eb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef91eb4",
  null
  
)

export default component.exports